import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const ACCEPT_INVITATION_MUTATION = gql`
  mutation AcceptInvitation($token: String!) {
    acceptInvitation(token: $token) {
      projectMembership {
        id
        project {
          id
          name
        }
        user {
          id
          fullName
        }
      }
    }
  }
`;

export function useAcceptInvitation() {
  const [acceptInvitationMutation, { loading, error }] = useMutation(ACCEPT_INVITATION_MUTATION);

  const acceptInvitation = async (token: string) => {
    const { data } = await acceptInvitationMutation({
      variables: { token },
    });
    return (data as any)?.acceptInvitation?.projectMembership;
  };

  return { acceptInvitation, loading, error };
}